export enum OrderStatus {
    All = "All",
    New = "New",
    Open = "Open",
    Released = "Released",
    Shipped = "Shipped",
    Partial = "Partial",
    Post = "Post",
    Closed = "Closed",
    Canceled = "Canceled",
    NotPlaced = "Not Placed",
    InProcess = "In Process",
    ClaimComplete = "Claim Complete"
}
